import Joi from "joi";

const callBack = (field: string) => {
	return Joi.custom((value, helpers) => {
		if (helpers.state.ancestors[0].stockNumber?.length || helpers.state.ancestors[0].vinNumber?.length || value.length) {
			return value;
		}
		return helpers.error(`Required.${field}`, {
			details: {
				message: `Required.${field}`,
				path: [field],
			},
		});
	}, `Required.${field}`);
};

export const transferRequestFilterSchema = Joi.object({
	status: Joi.array().items(Joi.string()).min(1).required(),
	location: Joi.array()
		.items(
			Joi.object({
				value: Joi.string().required(),
				group: Joi.string().required(),
			})
		)
		.min(2)
		.required(),
	make: callBack("make"),
});
